/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';


const SubtitleLineH2 = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'SubtitleLineH2',
    text: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    color: 'white',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isColorWhite, setColorWhite] = useState(true);

  const inputHandler = (e) => {
    const { value, name, lang } = e.target;

    const { component } = components[index];

    const comp = {
      ...component,
      [name]: {
        ...component[name],
        [lang.toLowerCase()]: value,
      },
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const setChangeColor = () => {
    setColorWhite(!isColorWhite);

    if (index >= 0 && components.length) {
      const { component } = components[index];
      const borderColor = !isColorWhite ? 'white' : 'black';

      const comp = {
        ...component,
        color: borderColor,
      };
      setState(comp);

      const componentObj = {
        id,
        component: comp,
      };

      handlerSetComponents(componentObj, index);
    }
  };

  return (
    <div className="w-full bg-greyFilter pl-5 rounded justify-around items-center flex flex-row">
      {languages.map(lang => (
        <div key={lang} className={`w-full ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} ${slider ? 'px-1 w-4/5' : 'pl-9 pb-6px w-full'}`}>
          <input className={`withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ${slider ? 'ml-1 p-1 text-sm' : ' p-2'}`} onChange={inputHandler} name="text" lang={lang} type="text" value={state.text[lang.toLowerCase()]} readOnly={reusableComponent && reusableComponent} />
        </div>
      ))}
      <label className={`flex flex-col font-americaMonoRegular ${slider ? 'text-xxs' : 'text-xs w-1/8 justify-center'} uppercase text-black pt-0 items-center px-2`}>
        Text Color
        <div className={`pb-0 ${slider ? 'mt-2px mx-2' : 'mt-6px ml-1'}`}>
          <label className="switch mb-0 pb-0 h-6">
            <input className="switch" checked={isColorWhite} onChange={setChangeColor} type="checkbox" />
            <div className="switch-slider btn-bw switch-round" />
          </label>
        </div>
      </label>
    </div>
  );
};

SubtitleLineH2.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
SubtitleLineH2.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default SubtitleLineH2;
